import React from 'react';
import { useLocale } from 'locale';
import { SmallText } from 'ds/components/typography';
import FeedbackIcon from 'assets/svg/feedback.svg';
import ChevronIcon from 'assets/svg/chevron-down.svg';
import CheckmarkIcon from 'assets/svg/checkmark-thin.svg';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { sendFeedbackResponseSelector } from 'store/state/mutationsResponse/selectors';
import {
  FeedbackSentWrapper,
  FeedbackDropdownWrapper,
  FeedbackDropdownButtonWrapper,
} from './styled';
import { setFeedbackPopupOpen as openPopup } from 'store/state/app/actions';
import { ISendFeedbackCallbackProps } from 'utils/entities';

interface FeedbackDropdownOwnProps {
  insightId: string;
}

interface FeedbackDropdownStateProps {
  isSent: boolean;
  insightId: string;
}
interface FeedbackDropdownMergeProps extends FeedbackDropdownStateProps{
  setFeedbackPopupOpen: (prop: ISendFeedbackCallbackProps) => void;
}

const FeedbackDropdownUnwrapped: React.FunctionComponent<FeedbackDropdownMergeProps> = ({ setFeedbackPopupOpen, isSent, insightId }) => {
  const { t } = useLocale();

  const openFeedbackPopup = () => setFeedbackPopupOpen({ isOpen: true, insightId });

  if (isSent) {
    return (
      <FeedbackSentWrapper data-auto="sent-feedback-wrapper">
        <SmallText>
          <CheckmarkIcon />
          {t('feedback.sent')}
        </SmallText>
      </FeedbackSentWrapper>
    );
  }

  return (
    <FeedbackDropdownWrapper onClick={openFeedbackPopup}>
      <FeedbackDropdownButtonWrapper>
        <FeedbackIcon width={24} height={24} />
        <SmallText data-auto="give-feedback">{t('expandedHighlight.feedbackDropdownLabel')}</SmallText>
        <ChevronIcon width={24} height={24} />
      </FeedbackDropdownButtonWrapper>
    </FeedbackDropdownWrapper>
  );
};

const mapStateToProps = (state: State, props: FeedbackDropdownOwnProps): FeedbackDropdownStateProps => {
  const responseData = sendFeedbackResponseSelector(state, props.insightId);
  return {
    isSent: responseData && responseData.data && responseData.data.feedback,
    insightId: props.insightId,
  };
};
const mapDispatchToProps = {
  setFeedbackPopupOpen: openPopup,
};

export const FeedbackDropdown = connect(mapStateToProps, mapDispatchToProps)(FeedbackDropdownUnwrapped);

